import { queryOptions } from '@tanstack/react-query';
import type {
  GetDevicesByUserIdData,
  GetDevicesResponse,
} from 'generated/openapi';

import { PrivateApi } from '@/shared/api/httpClient';

export const getRegisteredDevicesKey = () =>
  ['users', '@me', 'devices'] as const;

const getRegisteredDevicesUrl: GetDevicesByUserIdData['url'] =
  'users/@me/devices';

export const getRegisteredDevicesOptions = <T = GetDevicesResponse>() =>
  queryOptions<GetDevicesResponse, unknown, T>({
    queryKey: getRegisteredDevicesKey(),
    queryFn: () =>
      PrivateApi.get(getRegisteredDevicesUrl).json<GetDevicesResponse>(),
  });
